import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PanelmenuComponent } from './panelmenu.component';
import { PanelmenuRoutingModule } from './panelmenu-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {PanelMenuModule} from "../../component/ing/panelmenu/panelmenu";
import {TableModule} from "../../component/ing/table/table";


@NgModule({
  imports: [
    CommonModule,
    PanelmenuRoutingModule,
    FormsModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    PanelMenuModule,
    TableModule
  ],
  declarations: [PanelmenuComponent]
})
export class PanelmenuDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/panelmenu/panelmenuDemo.module.ts